import { type FunctionComponent } from 'react';

import { LoadingSpinner } from '@kanda-libs/ks-design-library';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const OmniSignDocumentsLoader: FunctionComponent = () => (
  <div className="m-auto">
    <PleaseWaitOverlay
      icon="check-circle-color"
      title="Your application has been approved"
      labelLine1="We're just fetching your documents that you need to sign from the lender. This shouldn't take long"
    />
    <LoadingSpinner size={50} stroke="purple-400" className="mx-auto mt-6" />
  </div>
);

export default OmniSignDocumentsLoader;
